import React, { Fragment } from 'react';
import { parseUnderlines } from '../../../utils/parseUnderlines';
import QuestionLink from './QuestionLink';

function QuestionHead({ question, toggleMedicationListModal, currentSection }) {
  return (
    <Fragment>
      {question.label && (
        <div className="new-assessment-detail__question-label">
          {question.label}
        </div>
      )}
      <div className="new-assessment-detail__question-content">
        <div className={'new-assessment-detail__number new-assessment-detail__number--' + currentSection.theme}>
          {question.index + 1}
        </div>
        <div className="new-assessment-detail__question-text">
          {parseUnderlines(question.content)}
          <QuestionLink
            question={question}
            toggleMedicationListModal={toggleMedicationListModal}
          />
        </div>
      </div>
      {question.subContent && (
        <div className="new-assessment-detail__question-subcontent">
          {question.subContent}
        </div>
      )}
    </Fragment>
  );
}

export default QuestionHead;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionHead.js